import type {MessageDescriptor} from 'react-intl';
import type {BaseHttpCodes} from '@igp/shared/api';
import type {TransactionErrorCodes} from '@igp/shared/features/transaction';
import {errorMessages} from '@igp/shared/intl';

type CustomStatusErrorCodes =
    | BaseHttpCodes
    | '400'
    | '10000'
    | '10000006'
    | '10000027'
    | '10000028'
    | '10000048'
    | '10000050'
    | '10000056'
    | '10000058'
    | '10000062'
    | '20000001'
    | '20000002'
    | '20000063'
    | '20000064';

export type CustomErrorCodesLocalizationKeys = `${string}/${CustomStatusErrorCodes}` | CustomStatusErrorCodes | TransactionErrorCodes;

export const customErrorCodesLocalization: Record<CustomErrorCodesLocalizationKeys, MessageDescriptor> = {
    401: errorMessages.notAuthorized,
    403: errorMessages.notEnoughPermissions,
    404: errorMessages.notFound,
    409: errorMessages.conflict,
    500: errorMessages.unhandledServerError,
    502: errorMessages.notAvailable,
    10000006: errorMessages.inputValidationIncorrectFormat,
    10000027: errorMessages.inputValidationValueNotExist,
    10000028: errorMessages.inputValidationNullValue,
    10000048: errorMessages.invalidNotificationContractType,
    10000050: errorMessages.unexpectedTransactionStatus,
    10000056: errorMessages.transactionWithSameIdAlreadyExists,
    10000058: errorMessages.handledExceptionOccurred,
    10000062: errorMessages.notEnoughFunds,
    20000001: errorMessages.fileUploadFailed,
    'action-center/saveWithdrawalLimitsFailed/400': errorMessages.userSetInvalidWithdrawalLimits,
    'action-center/updateStakeLimitsFailed/400': errorMessages.userBlockStakesFailed,
    'action-center/updateSecurityCaseFailed/409': errorMessages.userSecurityCasesConflict,
    'bot-detection/bot-player-view/updateBotCaseFailed/409': errorMessages.botCasesConflict,
    'marketing-code/deleteMarketingCodesFailed/10000': errorMessages.marketingCodeDeletingPartiallyFailed,
    'marketing-code/addMarketingCodeFailed/10000': errorMessages.marketingCodeAlreadyAvailable,
    'user-profile-actions/updatePlayerIdFailure/20000063': errorMessages.invalidSubagentRevenueShare,
    'user-profile-actions/updatePlayerIdFailure/20000064': errorMessages.noParentAgentRevenueShare,
    400: undefined,
    10000: undefined,
    20000002: undefined,
    20000063: undefined,
    20000064: undefined,
    20000100: undefined,
    20000101: undefined,
};
